import InnerComponent from '@Components/Quality/QualityControlPoints';
import orgContainer from '@Components/AppContainer';

const QCPointList = () => ((orgContainer(InnerComponent)));
export default QCPointList;